import React, { Component } from 'react';

class IconAttachment extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="17"
                fill="none"
                viewBox="0 0 13 17"
            >
                <path
                    fill="#1D53A5"
                    fillRule="evenodd"
                    d="M7.682.818H1.536C.691.818.008 1.51.008 2.354L0 14.645c0 .846.684 1.537 1.529 1.537h9.226a1.54 1.54 0 001.536-1.536V5.427L7.681.818zm-.768 5.377V1.97l4.225 4.225H6.914z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#fff"
                    d="M8.46 10.07l-2.02 2.995a1.256 1.256 0 11-2.083-1.405l2.196-3.255a.786.786 0 011.302.878L6.01 12.017a.315.315 0 01-.436.085.315.315 0 01-.084-.436l1.668-2.474-.39-.263-1.67 2.473a.786.786 0 001.303.879l1.844-2.734A1.256 1.256 0 106.162 8.14l-2.196 3.255a1.727 1.727 0 102.865 1.932l2.02-2.994-.39-.264z"
                ></path>
            </svg>
        );
    }
}

export default IconAttachment;